import React, { useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { Logo, cx } from "@/lib/ui";
import { useAuth } from "@/context/Auth";

const NAV = [
  { to: "/admin", end: true, icon: "fa-gauge", label: "Dashboard" },
  { to: "/admin/pending", icon: "fa-clock", label: "Pending Products" },
  { to: "/admin/products", icon: "fa-box", label: "Products" },
  { to: "/admin/sellers", icon: "fa-users", label: "All Sellers" },
  { to: "/admin/incomplete", icon: "fa-user-clock", label: "Incomplete Signups" },
  { to: "/admin/subscriptions", icon: "fa-crown", label: "Subscriptions" },
  { to: "/admin/add-product", icon: "fa-plus", label: "Add Product" },
  { to: "/admin/clicks", icon: "fa-hand-pointer", label: "Clicks History" },
  { to: "/admin/leads", icon: "fa-filter", label: "Leads" },
  { to: "/admin/referrals", icon: "fa-gift", label: "Referral Bonus" },
  { to: "/admin/referors", icon: "fa-user-tie", label: "Referor Management" },
  { to: "/admin/referor-payments", icon: "fa-money-bill-transfer", label: "Referor Payments" },
  { to: "/admin/invoices", icon: "fa-file-invoice", label: "GST Invoices" },
  { to: "/admin/payment-qr", icon: "fa-qrcode", label: "Payment QR" },
  { to: "/admin/restricted", icon: "fa-ban", label: "Restricted Items" },
  { to: "/admin/master", icon: "fa-database", label: "Master Data" },
  { to: "/admin/plans", icon: "fa-layer-group", label: "Package Planner" },
  { to: "/admin/holidays", icon: "fa-calendar-day", label: "Holiday Calendar" },
  { to: "/admin/instagram", icon: "fa-instagram", brand: true, label: "Instagram Schedule" },
  { to: "/admin/more", icon: "fa-ellipsis", label: "Payments · Testimonials · Buyers · Disclaimers" },
];

export default function AdminLayout() {
  const nav = useNavigate();
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);

  return (
    <div className="min-h-screen bg-slate-50 lg:flex">
      <aside className={cx(
        "fixed inset-y-0 left-0 z-40 w-64 transform overflow-y-auto border-r border-slate-800 bg-slate-950 p-4 text-slate-300 transition ds-scroll lg:static lg:translate-x-0",
        open ? "translate-x-0" : "-translate-x-full"
      )}>
        <div className="mb-6"><Logo dark /></div>
        <p className="mb-3 truncate rounded-lg bg-white/5 px-3 py-2 text-xs text-slate-400">{user?.email}</p>
        <nav className="space-y-1">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} onClick={() => setOpen(false)}
              data-testid={`admin-nav-${n.label.split(" ")[0].toLowerCase()}`}
              className={({ isActive }) => cx("flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition",
                isActive ? "bg-orange-600 text-white" : "hover:bg-white/5")}>
              <i className={`fa-${n.brand ? "brands" : "solid"} ${n.icon} w-4`} /> <span className="text-[13px]">{n.label}</span>
            </NavLink>
          ))}
          <button onClick={() => { logout(); nav("/"); }} data-testid="admin-logout"
            className="mt-4 flex w-full items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium text-red-300 hover:bg-red-500/10">
            <i className="fa-solid fa-arrow-right-from-bracket w-4" /> Logout
          </button>
        </nav>
      </aside>
      {open && <div className="fixed inset-0 z-30 bg-black/40 lg:hidden" onClick={() => setOpen(false)} />}
      <div className="flex-1">
        <header className="sticky top-0 z-20 flex items-center gap-3 border-b border-slate-200 bg-white px-4 py-3 lg:hidden">
          <button onClick={() => setOpen(true)}><i className="fa-solid fa-bars text-slate-700" /></button>
          <Logo />
        </header>
        <main className="mx-auto max-w-7xl px-4 py-6"><Outlet /></main>
      </div>
    </div>
  );
}
